"use client";

import React from "react";
import { LGSHeader } from "modules/lgs/components/stores/LGSHeader";
import { LGS } from "modules/lgs/model/lgs";

interface LGSHeaderClientProps {
  lgs: LGS;
  cityName?: string | null;
}

export function LGSHeaderClient({ lgs, cityName }: LGSHeaderClientProps) {
  return <LGSHeader lgs={lgs} cityName={cityName} />;
}
